document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('scroll-carousel');
  const prevButton = document.querySelector('carousel-prev-button > button');
  const nextButton = document.querySelector('carousel-next-button > button');
  const navWrapper = document.querySelector('.product-gallery__thumbnail-scroller');
  const upArrow = document.querySelector('.nav-arrow--up');
  const downArrow = document.querySelector('.nav-arrow--down');
  const navItems = carousel ? Array.from(document.querySelectorAll('.product-gallery__thumbnail')) : null;
  const navigationControls = document.querySelector('.navigation-controls');
  const imageList = document.querySelector('.product-gallery__image-list');
  const thumbnailList = document.querySelector('.product-gallery__thumbnail-list');

  if (!carousel || !prevButton || !nextButton || !navWrapper || !upArrow || !downArrow || !navItems || navItems.length === 0) {
    console.error('필수 요소를 찾을 수 없습니다. HTML 구조를 확인하세요.');
    return;
  }

  const carouselItems = Array.from(carousel.querySelectorAll('.product-gallery__media'));

  function updateAriaAttributes(newIndex) {
    carouselItems.forEach((item, index) => {
      const isCurrent = index === newIndex;
      item.setAttribute('aria-current', isCurrent ? 'true' : 'false');
      item.setAttribute('aria-label', `Item ${index + 1} of ${carouselItems.length}`);
    });

    navItems.forEach((item, index) => {
      const isCurrent = index === newIndex;
      item.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  function moveCarousel(newIndex) {
    const targetItem = carouselItems[newIndex];
    if (targetItem) {
      targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      updateAriaAttributes(newIndex);
    }
  }

  prevButton.addEventListener('click', () => {
    prevButton.removeAttribute('disabled');
    nextButton.removeAttribute('disabled');

    const currentIndex = carouselItems.findIndex(item => item.getAttribute('aria-current') === 'true');
    const newIndex = (currentIndex - 1 + carouselItems.length) % carouselItems.length;
    moveCarousel(newIndex);
  });

  nextButton.addEventListener('click', () => {
    prevButton.removeAttribute('disabled');
    nextButton.removeAttribute('disabled');

    const currentIndex = carouselItems.findIndex(item => item.getAttribute('aria-current') === 'true');
    const newIndex = (currentIndex + 1) % carouselItems.length;
    moveCarousel(newIndex);
  });

  function handleThumbnailNavigation() {
    const scrollStep = navItems[0]?.offsetHeight || 100;

    function moveNavigation(direction) {
      const maxScroll = navWrapper.scrollHeight - navWrapper.clientHeight;

      if (direction === 'down') {
        const newScrollTop = Math.min(navWrapper.scrollTop + scrollStep, maxScroll);
        navWrapper.scrollTo({ top: newScrollTop, behavior: 'smooth' });
      } else if (direction === 'up') {
        const newScrollTop = Math.max(navWrapper.scrollTop - scrollStep, 0);
        navWrapper.scrollTo({ top: newScrollTop, behavior: 'smooth' });
      }
    }

    upArrow.addEventListener('click', () => moveNavigation('up'));
    downArrow.addEventListener('click', () => moveNavigation('down'));
  }

  function updateNavigationControlsAndHeight() {
    if (!thumbnailList || !imageList || !navigationControls || !navWrapper) return;

    const carouselHeight = carousel.offsetHeight;
    navWrapper.style.maxHeight = `${carouselHeight}px`;

    const thumbnailHeight = thumbnailList.offsetHeight;
    const imageListHeight = imageList.offsetHeight;

    if (thumbnailHeight < imageListHeight) {
      navigationControls.style.display = 'none';
      thumbnailList.style.paddingTop = '0px';
      navWrapper.style.maxHeight = `${carouselHeight}px`; 
    } else {
      navigationControls.style.display = 'block';
      thumbnailList.style.paddingTop = '25px';
      navWrapper.style.maxHeight = `${carouselHeight - 25}px`;
    }
  }

  function initialize() {
    prevButton.removeAttribute('disabled');
    nextButton.removeAttribute('disabled');

    updateAriaAttributes(carouselItems.findIndex(item => item.getAttribute('aria-current') === 'true'));
    handleThumbnailNavigation();
    updateNavigationControlsAndHeight();
  }

  window.addEventListener('resize', updateNavigationControlsAndHeight);

  initialize();
});